import { render, staticRenderFns } from "./TypeStep.vue?vue&type=template&id=981df2ee&scoped=true&"
import script from "./TypeStep.vue?vue&type=script&lang=js&"
export * from "./TypeStep.vue?vue&type=script&lang=js&"
import style0 from "./TypeStep.vue?vue&type=style&index=0&id=981df2ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981df2ee",
  null
  
)

export default component.exports